import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { AnalyticsService } from '@app/core/_services/analytics.service'
import { DialogService } from '@app/core/_services/dialog.service'
import { MessageModule } from 'primeng/message'

const BANNER_NAME = 'Group Meeting: Beta Launch Host Announcement'
const BANNER_SOURCE = 'groupMeetingBetaLaunchHostAnnouncementBanner'

@Component({
    selector: 'fm-group-meeting-beta-launch-host-announcement-banner',
    standalone: true,
    imports: [MessageModule],
    templateUrl: './group-meeting-beta-launch-host-announcement-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupMeetingBetaLaunchHostAnnouncementBannerComponent implements OnInit {
    readonly pMessageScopedToken = {
        content: {
            gap: '0.5rem',
            padding: '0rem 0.5rem',
        },
        colorScheme: {
            dark: {
                warn: {
                    color: '{surface.700}',
                    shadow: '0 4px 8px 0 rgba(9, 7, 0, 0.04)',
                    simple: {
                        color: '{surface.700}',
                    },
                    outlined: {
                        color: '{surface.700}',
                        borderColor: '{surface.700}',
                    },
                    background: 'color-mix(in srgb, {orange.200}, transparent 5%)',
                    borderColor: '{yellow.200}',
                    closeButton: {
                        focusRing: {
                            color: '{surface.700}',
                            shadow: '0 0 0 0 #00000000',
                        },
                        hoverBackground: '{text.muted.color}',
                    },
                },
            },
            light: {
                warn: {
                    color: '{surface.700}',
                    shadow: '0 4px 8px 0 rgba(9, 7, 0, 0.04)',
                    simple: {
                        color: '{surface.700}',
                    },
                    outlined: {
                        color: '{surface.700}',
                        borderColor: '{surface.700}',
                    },
                    background: 'color-mix(in srgb, {orange.200}, transparent 5%)',
                    borderColor: '{yellow.200}',
                    closeButton: {
                        focusRing: {
                            color: '{surface.700}',
                            shadow: '0 0 0 0 #00000000',
                        },
                        hoverBackground: '{text.muted.color}',
                    },
                },
            },
        },
    }

    constructor(
        private analyticsService: AnalyticsService,
        private dialogService: DialogService,
    ) {}

    ngOnInit(): void {
        this.analyticsService.logViewedBannerEvent(BANNER_NAME, { source: BANNER_SOURCE })
    }

    onClickLearnMore(): void {
        this.analyticsService.logGroupMeetingClick('learnMoreAboutGroupMeetings', BANNER_SOURCE)
        this.dialogService.openGroupMeetingBetaLaunchHostAnnouncementDialog()
    }
}
